import React from 'react';

const AdminFooter: React.FC = () => {
  return (
    <footer className="border-t border-gray-200 bg-white/70 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 text-center text-sm text-gray-600">
        <span className="font-medium text-gray-700">Official Website:</span>{' '}
        <a
          href="https://www.iimdirect.com/"
          target="_blank"
          rel="noreferrer"
          className="font-semibold text-[#c31200] hover:text-[#a10f00] hover:underline"
        >
          iimdirect.com
        </a>
      </div>
    </footer>
  );
};

export default AdminFooter;
